import { Entity } from '@backstage/catalog-model';

export const userCache = new Map<string, Entity>();
